import {Col, Row} from "react-bootstrap/esm";
import './LiveStream.scss'
import HadisBox from "../HadisBox/HadisBox.tsx";
import IranSanse from "../Typography/IranSanse.tsx";
import ReactPlayer from 'react-player'
import {useEffect, useState} from "react";
import TopMenu from "../TopMenu/TopMenu.tsx";
import {Menu} from "../../Entities/Menu.ts";

const Cameras: Menu[] =
    [
        {
            "id": "5f8a3530-dff1-4801-8723-bed5d0b74dcf",
            "title": "دوربین 1",
            "link": '/Video/ImamReza.mp4',
            "iconId": '3f236202-5581-4a84-b914-e0993141656d',
            "parentId": null,
            "order": "1",
            "isActive": true
        },
        {
            "id": "98cbfe71-6392-40a5-adf1-b26399c6a32b",
            "title": "دوربین 2",
            "link": '/Video/imamAli.mp4',
            "iconId": 'c610d177-f239-49e1-a1bc-b0d452ead43a',
            "parentId": null,
            "order": "2",
            "isActive": true
        },
        {
            "id": "cd8ca639-55a3-4519-926a-aa61f572ad31",
            "title": "دوربین 3",
            "link": '/Video/imamHosein.mp4',
            "iconId": 'ab270609-1cdd-4c50-bd8b-21320fbf8d36',
            "parentId": null,
            "order": "3",
            "isActive": true
        }
    ]
export default function () {
    const [currentVideo, setCurrentVideo] = useState('');

    const [start, setStart] = useState(false)
    useEffect(() => {
        console.log('hello')
        // sleep(50).then(r => {
        setStart(true)
        // })
        setCurrentVideo('/Video/ImamReza.mp4')

    }, []);
    return <div>
        <Row className='g-0 '>
            <Col>
                <TopMenu Menus={Cameras} OnSelected={(menu) => {
                    setCurrentVideo(menu.link)
                }}/>
            </Col>
        </Row>
        <Row className={'g-0'}>
            <Col>
                <div>
                    <IranSanse>
                        <HadisBox className='my-1'>
                            <ReactPlayer width={'100%'} url={currentVideo} playing={start} controls={true}/>
                        </HadisBox>
                    </IranSanse>
                </div>
            </Col>
        </Row>
    </div>
}